import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <div className="contents" data-ai-id="root-route">
      <div className="contents" data-ai-id="root-route-outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
}
